import React, { useState, useRef } from "react";

import classes from "./CourseSelectionPage.scss";
import CourseFilters from "AppComponents/CourseSelection/components/CourseFilters";
import CourseList from "AppComponents/CourseSelection/components/CourseList";

const CourseSelectionPage = ({
  selectedCurriulum,
  selectedIds,
  handleSelect,
  fetchTemplates,
  selectedGradeId,
  onChangeGradeId,
  selectedSubjectId,
  onChangeSubjectId,
  selectedGlobalGradeUid,
  shouldCheckIfTermsExist,
  shouldDisplaySubjects,
  academicYears,
  courseSubjectType,
  loadingCurriculums,
}) => {
  const [searchText, setSearchText] = useState("");
  const [subjects, setSubjects] = useState([]);

  const containerRef = useRef(null);

  const onSearchTextChange = value => {
    setSearchText(value);
  };

  return (
    <div className={classes.container} ref={containerRef}>
      <CourseFilters
        searchText={searchText}
        onSearchTextChange={onSearchTextChange}
        selectedGradeId={selectedGradeId}
        onChangeGradeId={onChangeGradeId}
        selectedSubjectId={selectedSubjectId}
        onChangeSubjectId={onChangeSubjectId}
        selectedCurriulum={selectedCurriulum}
        selectedGlobalGradeUid={selectedGlobalGradeUid}
        shouldDisplaySubjectsFilter={shouldDisplaySubjects}
        courseSubjectType={courseSubjectType}
        setSubjects={setSubjects}
      />
      <CourseList
        searchText={searchText}
        selectedCurriulum={selectedCurriulum}
        selectedIds={selectedIds}
        handleSelect={handleSelect}
        containerRef={containerRef}
        fetchTemplates={fetchTemplates}
        selectedGradeId={selectedGradeId}
        selectedSubjectId={selectedSubjectId}
        shouldCheckIfTermsExist={shouldCheckIfTermsExist}
        shouldDisplaySubjects={shouldDisplaySubjects}
        academicYears={academicYears}
        courseSubjectType={courseSubjectType}
        subjects={subjects}
        loadingCurriculums={loadingCurriculums}
      />
    </div>
  );
};

export default CourseSelectionPage;
